import * as React from "react";

import styles from "./styles.module.scss";

const Separator: React.FC = () => <hr className={styles["separator"]} />;

export default Separator;
